/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from "react";
import { Redirect } from "react-router-dom";
import Dashboard from "src/layouts/Dashboard";
import ErrorLayout from "src/layouts/ErrorLayout";

export default [
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/lista-presupuesto" />,
  },
  {
    path: "/errors",
    component: ErrorLayout,
    routes: [
      {
        path: "/errors/error-404",
        exact: true,
        component: lazy(() => import("src/views/Error404View")),
      },
      {
        component: () => <Redirect to="/errors/error-404" />,
      },
    ],
  },
  {
    path: "*",
    component: Dashboard,
    routes: [
      {
        path: "/detalle-presupuesto/:idPresupuesto",
        exact: true,
        component: lazy(() => import("src/views/presupuesto/VistaPresupuesto")),
      },
      {
        path: "/lista-presupuesto",
        exact: true,
        component: lazy(() =>
          import("src/views/presupuesto/ListaPresupuestos")
        ),
      },
      {
        component: () => <Redirect to="/errors/error-404" />,
      },
    ],
  },
  {
    component: () => <Redirect to="/errors/error-404" />,
  },
];
